import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

/** A read-only field with a Copy button; says "Copied" for a moment. */
function CopyField({ id, label, value, multiline = false }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return undefined;
    const t = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(t);
  }, [copied]);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      // Clipboard blocked (http, permissions): the field is selectable.
    }
  };
  return (
    <div className="mb-4 grid gap-1.5">
      <Label htmlFor={id} className="mb-1">
        {label}
      </Label>
      <div className="flex min-w-0">
        {multiline ? (
          <Textarea
            id={id}
            readOnly
            rows={2}
            value={value}
            onFocus={(e) => e.target.select()}
            className="max-h-40 min-w-0 [field-sizing:fixed] resize-none rounded-r-none font-mono text-sm"
          />
        ) : (
          <Input
            id={id}
            readOnly
            value={value}
            onFocus={(e) => e.target.select()}
            className="min-w-0 rounded-r-none font-mono text-sm"
          />
        )}
        <Button
          variant="outline"
          type="button"
          onClick={copy}
          aria-label={`Copy ${label}`}
          className="shrink-0 rounded-l-none border-l-0"
        >
          {copied ? "Copied" : "Copy"}
        </Button>
      </div>
    </div>
  );
}

CopyField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  multiline: PropTypes.bool,
};

export default CopyField;
